/**
 * Icon component - иконка для секций
 * Обертка над SvgIcon с дополнительными стилями
 */
import { SvgIcon, getIconNames, hasIcon } from '../../utils/icons';

// Пресеты размеров
const sizePresets = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
  '2xl': 40,
  '3xl': 48,
};

// Пресеты цветов
const colorClasses = {
  inherit: '',
  current: 'text-current',
  primary: 'text-primary',
  secondary: 'text-text-secondary',
  muted: 'text-muted-foreground',
  white: 'text-white',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
};

export default function Icon({
  name,
  size = 'md',       // xs, sm, md, lg, xl, 2xl, 3xl или число
  color = 'inherit', // inherit, current, primary, secondary, muted, white, success, warning, error
  strokeWidth = 2,
  className = '',
  style,
  ...props
}) {
  if (!name || !hasIcon(name)) {
    return null;
  }

  // Определяем размер
  const pixelSize = typeof size === 'number' ? size : (sizePresets[size] || sizePresets.md);

  // Собираем классы
  const classes = [
    colorClasses[color] || '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <SvgIcon
      name={name}
      size={pixelSize}
      strokeWidth={strokeWidth}
      className={classes}
      style={style}
      {...props}
    />
  );
}

// Экспорт для использования в настройках
Icon.sizes = Object.keys(sizePresets);
Icon.colors = Object.keys(colorClasses);
Icon.names = getIconNames();
Icon.hasIcon = hasIcon;
